import { FlashcardsDeckChoicePicker } from "src/components/NewComponents/Creator/ContentPicker/FlashcardsDeckChoicePicker";

import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

export function FlashcardsDeckChoiceContainer() {
	return (
		<LayoutWithSearch>
			<FlashcardsDeckChoicePicker />
		</LayoutWithSearch>
	);
}
